import { render, staticRenderFns } from "./TerminalWindow.vue?vue&type=template&id=264cf1d1&scoped=true&"
import script from "./TerminalWindow.vue?vue&type=script&lang=js&"
export * from "./TerminalWindow.vue?vue&type=script&lang=js&"
import style0 from "./TerminalWindow.vue?vue&type=style&index=0&id=264cf1d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264cf1d1",
  null
  
)

export default component.exports